import * as React from "react";
import { PopoverClose } from "~/sharedComponents/popover/types";
import { CloseReason } from "../../sharedHOC/ClickOutside/ClickOutside";

export type PopupState = {
    lastCloseReason?: CloseReason;
    close: PopoverClose;
};

export const PopoverPopupStateContext = React.createContext<F<PopupState>>(null);

export const usePopupStateGetter = () => React.useContext(PopoverPopupStateContext);
